import type { AgentToolRegistry } from '../../../../core/ai/agent/AgentToolRegistry';
import { complianceQueryTool } from './complianceQueryTool';
import { roleQueryTool } from './roleQueryTool';
import { criticalPathTool } from './criticalPathTool';
import { managementSummaryTool } from './managementSummaryTool';
import { proposeProcessChangesTool } from './proposeProcessChangesTool';
import { setShapeColorTool } from './setShapeColorTool';

export const registerProcessAgentTools = (registry: AgentToolRegistry): void => {
  registry.register(complianceQueryTool);
  registry.register(roleQueryTool);
  registry.register(criticalPathTool);
  registry.register(managementSummaryTool);
  registry.register(setShapeColorTool);
  // Change-set editing: small, reliable edits to an existing diagram that
  // compile to canvas commands (canvas owns layout). Preferred over rdm_apply
  // for any modification of an existing process diagram.
  registry.register(proposeProcessChangesTool);
};
